import * as React from 'react';
import { Image } from '@cian/ui-kit';

const manShruggingShoulders = require('../../assets/manShruggingShoulders.png');

export const AlertNotFoundIcon: React.FC = () => {
  return <Image src={manShruggingShoulders} height={40} width={40} objectFit="contain" />;
};
